import React from "react";
import { Form, Button } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { FaUpload } from "react-icons/fa";
import letterAz from "../assets/letter_AZ.pdf";
import letterEn from "../assets/letter_EN.pdf";
const DocumentUpload = ({
  form,
  setForm,
  errors,
  handleSubmit,
  handleBack,
}) => {
  const { t, i18n } = useTranslation();
  const acceptedFileTypes = {
    "application/pdf": [".pdf"],
    "image/jpeg": [".jpg", ".jpeg"],
    "image/png": [".png"],
    "image/gif": [".gif"],
  };
  const maxFileSize = 5 * 1024 * 1024; // 5 MB in bytes

  const dropzoneFormalApplicationLetter = useDropzone({
    accept: acceptedFileTypes,
    maxSize: maxFileSize,
    onDrop: (acceptedFiles, fileRejections) => {
      if (fileRejections.length > 0) {
        fileRejections.forEach((rejection) => {
          rejection.errors.forEach((error) => {
            alert(error.message);
          });
        });
      } else {
        setForm({ ...form, formalApplicationLetter: acceptedFiles[0] });
      }
    },
  });

  const dropzonePassportPhoto = useDropzone({
    accept: acceptedFileTypes,
    maxSize: maxFileSize,
    onDrop: (acceptedFiles, fileRejections) => {
      if (fileRejections.length > 0) {
        fileRejections.forEach((rejection) => {
          rejection.errors.forEach((error) => {
            alert(error.message);
          });
        });
      } else {
        setForm({ ...form, passportSizePhoto: acceptedFiles[0] });
      }
    },
  });

  const dropzonePressCardScan = useDropzone({
    accept: acceptedFileTypes,
    maxSize: maxFileSize,
    onDrop: (acceptedFiles, fileRejections) => {
      if (fileRejections.length > 0) {
        fileRejections.forEach((rejection) => {
          rejection.errors.forEach((error) => {
            alert(error.message);
          });
        });
      } else {
        setForm({ ...form, pressCardScan: acceptedFiles[0] });
      }
    },
  });

  const dropzoneRegisterCertificate = useDropzone({
    accept: acceptedFileTypes,
    maxSize: maxFileSize,
    onDrop: (acceptedFiles, fileRejections) => {
      if (fileRejections.length > 0) {
        fileRejections.forEach((rejection) => {
          rejection.errors.forEach((error) => {
            alert(error.message);
          });
        });
      } else {
        setForm({ ...form, registerCertificate: acceptedFiles[0] });
      }
    },
  });


  const dropzoneIdScan = useDropzone({
    accept: acceptedFileTypes,
    maxSize: maxFileSize,
    onDrop: (acceptedFiles, fileRejections) => {
      if (fileRejections.length > 0) {
        fileRejections.forEach((rejection) => {
          rejection.errors.forEach((error) => {
            alert(error.message);
          });
        });
      } else {
        setForm({ ...form, idScan: acceptedFiles[0] });
      }
    },
  });
  const renderDocumentUploadField = (name, dropzoneProps) => (
    <Form.Group
      controlId={`form${name.charAt(0).toUpperCase() + name.slice(1)}`}
      className="mt-3"
    >
      <Form.Label className={name === "registerCertificate" && "m-0"}>{t(`personalInformation.${name}`)}  {name !== "registerCertificate" && "*"}</Form.Label>
      {name === "registerCertificate" && <span style={{ display: "block", color: "red" }}>
        {t("personalInformation.registerNote")}</span>}
      <p className="text-muted p-small" style={{ fontStyle: 'italic' }}>
        {t("personalInformation.allowedFileTypes")}: JPG, PNG, GIF & PDF -{" "}
        {t("personalInformation.maxFileSize")}: 5 MB
      </p>
      <div {...dropzoneProps.getRootProps({ className: "dropzone" })}>
        <input {...dropzoneProps.getInputProps()} name={name} required />
        <FaUpload
          style={{
            fontSize: "2rem",
            marginBottom: "10px",
            color: "var(--ocean-teal)",
          }}
        />
        <p>{t("personalInformation.dragAndDrop")}</p>
      </div>
      {form[name] && (
        <p>
          {t("personalInformation.selectedFile")}: {form[name].name}
        </p>
      )}
      <Form.Control isInvalid={!!errors[name]} style={{ display: "none" }} />
      <Form.Control.Feedback type="invalid" style={{ marginTop: "0.5rem" }}>
        {t("validation.field")}
      </Form.Control.Feedback>
    </Form.Group>
  );

  return (
    <>
      <h3 className='border-h3'>
        {t("personalInformation.uploadDocuments")}
      </h3>
      <p className='mark-message' style={{ maxWidth: "50%", color: "#016871" }}>
        {t("header.mandatory")}
      </p>
      <Form.Group controlId={`formApplicationLetter`} className="mt-3">

        <Form.Label>
          {t(`personalInformation.formalApplicationLetter`)}
          <a
            rel="noreferrer"
            target="_blank"
            href={i18n.language === "az" ? letterAz : letterEn
            }
            download={`AssignmentLetter_${i18n.language.toUpperCase()}.pdf`} // This forces the download
          >
            {t(`personalInformation.formalApplicationLetterLink`)}
          </a>{" "}
          *
        </Form.Label>
        <p className="text-muted p-small" style={{ fontStyle: 'italic' }}>
          {t("personalInformation.allowedFileTypes")}: JPG, PNG, GIF & PDF -{" "}
          {t("personalInformation.maxFileSize")}: 5 MB
        </p>
        <div
          {...dropzoneFormalApplicationLetter.getRootProps({
            className: "dropzone",
          })}
        >
          <input
            {...dropzoneFormalApplicationLetter.getInputProps()}
            name="formalApplicationLetter"
            required
          />
          <FaUpload
            style={{
              fontSize: "2rem",
              marginBottom: "10px",
              color: "var(--ocean-teal)",
            }}
          />
          <p>{t("personalInformation.dragAndDrop")}</p>
          {/* <p className="text-muted" style={{ fontStyle: 'italic' }}>
            {t("personalInformation.allowedFileTypes")}: JPG, PNG, GIF & PDF -{" "}
            {t("personalInformation.maxFileSize")}: 5MB
          </p> */}
        </div>
        {form["formalApplicationLetter"] && (
          <p>
            {t("personalInformation.selectedFile")}:{" "}
            {form["formalApplicationLetter"].name}
          </p>
        )}
        <Form.Control
          isInvalid={!!errors["formalApplicationLetter"]}
          style={{ display: "none" }}
        />
        <Form.Control.Feedback type="invalid" style={{ marginTop: "0.5rem" }}>
          {t("validation.field")}
        </Form.Control.Feedback>
      </Form.Group>
      {renderDocumentUploadField("passportSizePhoto", dropzonePassportPhoto)}
      {renderDocumentUploadField("pressCardScan", dropzonePressCardScan)}
      {renderDocumentUploadField("registerCertificate", dropzoneRegisterCertificate)}
      {renderDocumentUploadField("idScan", dropzoneIdScan)}

      {/* Agreement Checkboxes */}
      <Form.Group
        controlId="formConfirmAccuracy"
        className="mt-3"
        style={{ color: "#016871", fontWeight: "normal" }}
      >
        <Form.Check
          type="checkbox"
          label={
            <span className="custom-label">
              {/* <span style={{ color: "red", paddingRight: "2px" }}>*</span> */}
              {t("personalInformation.agreeToShareInfo")}
            </span>
          }
          name="agreeToShareInfo"
          checked={form.agreeToShareInfo}
          onChange={(e) =>
            setForm({ ...form, agreeToShareInfo: e.target.checked })
          }
          required
        />
      </Form.Group>
      <Form.Group
        controlId="formConfirmAccuracy"
        className="mt-3"
        style={{ color: "#016871", fontWeight: "normal" }}
      >
        <Form.Check
          type="checkbox"
          label={
            <span className="custom-label">
              {/* <span style={{ color: "red", paddingRight: "2px" }}>*</span> */}
              {t("personalInformation.confirmAccuracy")}
            </span>
          }
          name="confirmAccuracy"
          checked={form.confirmAccuracy}
          onChange={(e) =>
            setForm({ ...form, confirmAccuracy: e.target.checked })
          }
          required
        />
      </Form.Group>
      <Button variant="secondary" onClick={handleBack} className="mt-3 btn-yellow">
        {t("back")}
      </Button>
      <Button
        style={{ background: "var(--ocean-teal)", color: "white" }}
        onClick={handleSubmit}
        className="mt-3 ms-2"
        disabled={!form.agreeToShareInfo || !form.confirmAccuracy}
      >
        {t("submit")}
      </Button>
    </>
  );
};

export default DocumentUpload;
